module.exports = __webpack_public_path__ + "static/media/home_service.c686a203.svg";